import { Box } from '@material-ui/core';
import { AutoAssetDetails, formatMoney } from '@nemuru-eng/js-api-client';

import {
  SELECT_BODY_TYPE,
  SELECT_CATEGORY_TYPE,
  SELECT_FUEL_TYPE,
  SELECT_GEAR_TYPE,
  SELECT_IS_NEW_VEHICLE,
} from '@/components/modules/AssetDetails/constants/constants';
import { FormGridContainer } from '@/components/shared/components/FormGridContainer/FormGridContainer';
import { FormGridOptions } from '@/components/shared/components/FormGridContainer/types/formGridOptions';
import { DateFormField } from '@/components/shared/components/NewContextForms/DateFormField';
import { NumberFormField } from '@/components/shared/components/NewContextForms/NumberFormField';
import { SelectFormField } from '@/components/shared/components/NewContextForms/SelectFormField';
import { TextFormField } from '@/components/shared/components/NewContextForms/TextFormField';
import { Text } from '@/components/shared/components/Text';

interface AutoDetailsProps extends FormGridOptions {
  assetDetails: AutoAssetDetails;
}

export const AutoDetailsForm = ({ assetDetails, fieldVariant, fullWidth }: AutoDetailsProps) => {
  return (
    <>
      <Box pt={2}>
        <FormGridContainer fullWidth={fullWidth} fieldVariant={fieldVariant}>
          <TextFormField name={'description'} label={'DESCRIPTION'} value={assetDetails.description} />
          <NumberFormField
            name={'amount'}
            label={'VEHICLE_AMOUNT'}
            value={formatMoney({ value: assetDetails.value.amount, currency: assetDetails.value.currency }, 2)}
          />
        </FormGridContainer>
      </Box>
      <Box pt={3}>
        <FormGridContainer fullWidth={fullWidth} fieldVariant={fieldVariant}>
          <TextFormField
            name={'brand'}
            label={'BRAND'}
            value={`${assetDetails.brand}${assetDetails.brandCode ? ` (${assetDetails.brandCode})` : ''}`}
          />
          <TextFormField
            name={'model'}
            label={'MODEL'}
            value={`${assetDetails.model}${assetDetails.modelCode ? ` (${assetDetails.modelCode})` : ''}`}
          />
          <TextFormField
            name={'version'}
            label={'VERSION'}
            value={`${assetDetails.modelVersion}${
              assetDetails.modelVersionCode ? ` (${assetDetails.modelVersionCode})` : ''
            }`}
          />
          <TextFormField
            name={'licensePlateNumber'}
            label={'LICENSE_PLATE_NUMBER'}
            value={assetDetails.usage?.plateNumber}
          />
          <TextFormField
            name={'identificationNumber'}
            label={'IDENTIFICATION_NUMBER'}
            value={assetDetails.specs?.identificationNumber}
          />
          <DateFormField
            name={'registrationDate'}
            label={'REGISTRATION_DATE'}
            value={assetDetails.specs?.registrationDate}
          />
        </FormGridContainer>
        <Box pt={3} />
        <FormGridContainer fullWidth={fullWidth} fieldVariant={fieldVariant}>
          <TextFormField name={'odometer'} label={'ODOMETER'} value={assetDetails.usage?.odometer} valueUnit={'KM'} />
          <TextFormField
            name={'power'}
            label={'MAX_POWER'}
            value={assetDetails.specs?.power}
            valueUnit={<Text tId={'CV'} />}
          />
          <TextFormField
            name={'engine'}
            label={'ENGINE'}
            value={assetDetails.specs?.engine}
            valueUnit={<Text tId={'CM_3'} />}
          />
          <SelectFormField
            name={'fuelType'}
            label={'FUEL_TYPE'}
            value={assetDetails.specs?.fuelType}
            selectOptions={SELECT_FUEL_TYPE}
          />
          <SelectFormField
            name={'category'}
            label={'CATEGORY'}
            value={<Text tId={assetDetails.category} />}
            selectOptions={SELECT_CATEGORY_TYPE}
          />
          <SelectFormField
            name={'bodyType'}
            label={'BODY_TYPE'}
            value={assetDetails.specs?.bodyType}
            selectOptions={SELECT_BODY_TYPE}
          />
          <SelectFormField
            name={'gear'}
            label={'GEAR_TYPE'}
            value={assetDetails.specs?.gear}
            selectOptions={SELECT_GEAR_TYPE}
          />
          <SelectFormField
            name={'isNewVehicle'}
            label={'IS_NEW_VEHICLE'}
            value={assetDetails.isNewVehicle ? 'YES' : 'NO'}
            selectOptions={SELECT_IS_NEW_VEHICLE}
          />
          <SelectFormField
            name={'imported'}
            label={'IMPORTED'}
            value={assetDetails.specs?.imported ? 'YES' : 'NO'}
            selectOptions={SELECT_IS_NEW_VEHICLE}
          />
        </FormGridContainer>
      </Box>
    </>
  );
};
